import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Spark } from '@/components/kit/spark'

interface SectionLabelProps {
    children: ReactNode
    index?: string
    tone?: 'ink' | 'cream'
    className?: string
}

export const SectionLabel: FC<SectionLabelProps> = ({ children, index, tone = 'ink', className }) => {
    return (
        <p className={cn('flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.16em]', tone === 'cream' ? 'text-cream/70' : 'text-stone', className)}>
            {index && (
                <span className={tone === 'cream' ? 'text-cream' : 'text-ink'}>
                    [{index}]
                </span>
            )}
            <Spark className='size-2.5 shrink-0 text-ember' />
            <span>
                {children}
            </span>
        </p>
    )
}
